<template>
  <div class="activity-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" title="活动中心" :showBack="true"></my-header>
    <div class="activity-tab-part">
      <div class="top-tab-item" :class="{'tab-selected':tabSelected == '0'}" @click = "change('0')">当前活动</div>
      <div class="top-tab-item" :class="{'tab-selected':tabSelected == '4'}" @click = "change('4')">往期活动</div>
      <div class="top-tab-item" :class="{'tab-selected':tabSelected == '1'}" @click = "change('1')">补贴活动</div>
    </div>
    <div v-if="tabSelected == '0' && activityList.length> 0" v-for="activity in activityList" class="activity-part" @click="toActivityDetail(activity.type,activity.id,activity.title,activity.content)">
      <div class="activity-item general-box-shadow">
        <img class="activity-item-banner" :src="imgUrl+activity.banner | ossProcess(750, 400)">
        <div class="activity-item-info">
          <div class="cell">
            <div class="label">活动时间：</div><div class="content">{{activity.activityDay}}</div>
          </div>
          <div  v-if="activity.address" class="cell">
            <div class="label">活动地点：</div><div class="content">{{activity.address}}</div>
          </div>
          <div class="cell">
            <div class="label">活动内容：</div><div class="content">{{activity.title}}</div>
          </div>
          <div class="cell">
            <div class="label">活动状态：</div><div class="content" style="color:#feac00;">进行中</div>
          </div>
        </div>
      </div>
    </div>
    <div class="black-page" v-if="tabSelected == '0' && activityList.length == 0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">暂无进行中的活动，敬请期待</div>
    </div>
    <div v-if="tabSelected == '1'" class="activity-list">
      <div class="article-item  general-box-shadow" v-for="(article,index) in articleList" :class="{}" @click="toArticleDetail(article.id,article.title)">
        <img class="article-cover" :src="article.cover">
        <div class="article-content">
          <div class="article-content-title">{{article.title}}</div>
          <div class="article-content-summary">{{article.summary}}</div>
        </div>
      </div>
    </div>
    <div v-if="tabSelected == '4'" class="activity-list">
      <div class="article-item general-box-shadow" v-for="(activity,index) in activityList" :class="{}" @click="toActivityDetail(activity.type,activity.id,activity.title,activity.content)">
        <img class="article-cover" :src="imgUrl+activity.banner">
        <div class="article-content">
          <div class="article-content-title">{{activity.title}}</div>
          <div class="article-content-info">
            <div v-if="activity.activityDay">活动时间 :&nbsp;&nbsp;{{activity.activityDay}}</div>
            <div>活动状态 :&nbsp;&nbsp;已结束</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import session from '../../utils/Session'
  import {imgUrl,shareIcon} from "../../config";
  import activityService from '../../service/activity/ActivityService'
  import shareService from '../../service/share/ShareService'
  import envUtils from '../../utils/EnvUtils'

  export default {
    name: 'ActivityList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        imgUrl: imgUrl,
        shareIcon:shareIcon,
        tabSelected:'0',
        activityList:[],
        articleList:[],
        pageNo:1,
        sortType:'1',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      if (this.global.tabSelected) {
        this.tabSelected = this.global.tabSelected;
        if(this.tabSelected == '0'){
          this.loadActivityList();
          this.sortType = '1';
        }else if(this.tabSelected == '1'){
          this.loadArticleList();
        }else if(this.tabSelected == '4'){
          this.sortType = '2';
          this.loadOfflineActivityList();
        }
        this.global.tabSelected = '';
      }else {
        this.loadActivityList();
      }
      this.initWechatShare();
    },
    methods: {
      change(status){
        this.tabSelected = status;
        if(this.tabSelected == '0'){
          this.sortType = '1';
          this.loadActivityList();
        }else if(this.tabSelected == '1'){
          this.loadArticleList();
        }else if(this.tabSelected == '4'){
          this.sortType = '2';
          this.loadOfflineActivityList();
        }
      },
      async loadActivityList(){
        let {code,msg,data} = await activityService.list(this.sortType);
        if(code == '0'){
          this.activityList = data.activityList;
        }else {
          Toast(msg);
        }
      },
      async loadOfflineActivityList(){
        this.activityList = [];
        let {code,msg,data} = await activityService.list(this.sortType,this.tabSelected);
        if(code == '0'){
          for(let activity of data.activityList){
            if(activity.title.length>16){
              activity.title = activity.title.substring(0,13)+'...'
            }
            if(activity.activityDay && activity.activityDay.length>25){
              activity.activityDay = activity.activityDay.substring(0,24)+'...'
            }
            this.activityList.push(activity)
          }
        }else {
          Toast(msg);
        }
      },
      async loadArticleList(){
        if(this.pageNo == 1){
          this.articleList = [];
        }
        let {code,msg,data} = await activityService.historyList();
        if(code == '0'){
          for(let article of data){
            if(article.title.length>14){
              article.title = article.title.substring(0,13)+'...'
            }
            this.articleList.push(article)
          }
        }else {
          Toast(msg);
        }
      },
      //跳转活动详情
      async toActivityDetail(type,id,title,content){
        const isLogin = await session.isLogin();
        if(isLogin){
          if(type != '2'){
            this.global.tabSelected =this.tabSelected;
            this.$router.push({name: 'ActivityDetail', query: {activityId:id}})
          }else {
            this.$router.push({name: 'ActivitySupervisor', query: {activityId:id,activityTitle:title}})
          }
        }else {
          session.userType('1');
          let backUrl = window.location.href.split('#')[1];
          if (envUtils.inLight()) {
            wx.miniProgram.navigateTo({url: `/pages/register/register?h5Url=${encodeURIComponent(backUrl)}`});
          } else {
            session.backUrl(backUrl)
            this.$router.push({name:'BindPhone'});
          }
        }
      },
      //跳转文章详情
      toArticleDetail(id,title){
        this.global.tabSelected =this.tabSelected;
        this.$router.push({name: 'ArticleDetail', query: {articleId:id,title}})
      },
      async initWechatShare(){
        let title = "水木家居商城活动中心";// 分享标题
        let desc = "又一大波优惠强势来袭！！！"; // 分享描述
        let link = window.location.href;  // 分享链接
        link = link.replace(/#/, '?#');
        await shareService.wechatShare(title,desc,link,this.shareIcon);
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .activity-page{
    padding-bottom: 0.5rem;
    font-size: 0.28rem;
    color: #7f7d7c;
    background-color: white;
    .no-activity{
      padding-top: 1rem;
      font-size: 0.25rem;
      color: #878e99;
      text-align: center;
      img{
        width: 1.5rem;
        margin-bottom: 0.5rem;
      }
    }
    .activity-tab-part{
      display: flex;
      width: 6.9rem;
      margin: 0 auto;
      height: 0.96rem;
      line-height: 1rem;
      font-size: 0.32rem;
      color: #7f7d7c;
      .top-tab-item{
        margin-right: 0.3rem;
      }
      .tab-selected{
        font-size: 0.36rem;
        color: #191818;
        font-weight: bold;
      }
    }
    .activity-part{
      width: 6.9rem;
      margin: 0rem auto 0.3rem;
      .activity-item{
        border-radius: 0.1rem;
        .activity-item-banner{
          width: 100%;
          height: 4rem;
          border-top-left-radius: 0.1rem;
          border-top-right-radius: 0.1rem;
        }
        .activity-item-info{
          margin-left: 0.3rem;
          line-height: 0.5rem;
          padding-bottom: 0.2rem;
          padding-top: 0.15rem;
          .cell{
            display: flex;
            .label{
              width: 1.4rem;
              margin-top: 0.02rem;
            }
            .content{
              width: 5rem;
              text-align: justify;
              font-size: 0.32rem;
              color: #191818;
            }
          }
        }
      }
    }
    .activity-part:first-child{
      margin-top: 0rem;
    }
    .article-item{
      display: flex;
      width: 6.9rem;
      height: 1.69rem;
      padding: 0;
      margin: 0 auto 0.21rem;
      .article-cover{
        display: block;
        width: 1.3rem;
        height: 1.3rem;
        margin-top: 0.19rem;
        margin-left: 0.2rem;
        margin-bottom: 0.2rem;
        border-radius: 6px;
      }
      .article-content{
        width: 5.4rem;
        padding-left: 0.3rem;
        .article-content-title{
          margin-top: 0.18rem;
          margin-bottom: 0.1rem;
          font-size: 0.32rem;
          color: #191818;
        }
        .article-content-info{
          margin-top: 0.15rem;
          line-height: 0.35rem;
        }
      }
    }
  }
</style>
